















import { Vue, Prop, Component } from 'vue-property-decorator'

@Component
export default class Menu extends Vue {
    // Prop => Datas envoyée depuis le composent parent à l'enfant (ici)
    @Prop() public Menus!: Array<string>
    @Prop() public step!: number
    @Prop() public ready!: boolean
    public updateClass (index: number): string {
      let className = ''
      if (this.step === index + 1) {
        className = 'visited'
      } else if (this.step > index + 1) {
        className = 'was-visited'
      } else {
        className = 'no-visited'
      }
      return className
    }

    public removeModifieOption (index: number): number {
      if ((this.$store.getters.getValueForStep1 === 'Professionnel' || this.$store.getters.getValueForStep1 === 'Je me renseigne') && index === 2) {
        return 0
      } else if ((this.$store.getters.getValueForStep1 === 'Professionnel' && index === 4) || (this.$store.getters.getValueForStep1 === 'Professionnel' && index === 5)) {
        return 0
      } else {
        if (this.step > index + 1) {
          return 1
        }
      }
      return 2
    }

    public updateMenuEntry (item :string, index: number): string {
      if (this.$store.getters.getValueForStep1 === 'Je me renseigne' && index === 5) {
        item = 'Un guide / Les prix'
      }
      return item
    }
}
